module.exports = __webpack_public_path__ + "media/images/vector-7@2x-4de1cd4746dc7d75ddaec853dd7282e2.png";